import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.jsx';
import reportWebVitals from './reportWebVitals.js';
import { initKeycloak } from './auth.js';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Show loading state while Keycloak initializes
root.render(
  <div style={{ fontFamily: '-apple-system, BlinkMacSystemFont, "Inter", sans-serif', display: 'flex', height: '100vh', background: '#0f172a', color: '#e2e8f0', alignItems: 'center', justifyContent: 'center' }}>
    <div style={{ textAlign: 'center' }}>
      <div style={{ fontSize: 20, fontWeight: 700, marginBottom: 8 }}>CoreBank</div>
      <div style={{ fontSize: 13, color: '#64748b' }}>Authenticating...</div>
    </div>
  </div>
);

initKeycloak()
  .then(() => {
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );

    // Back-button trap: prevent browser from leaving the SPA
    window.history.replaceState(null, '', '/');
    window.addEventListener('popstate', () => {
      window.history.pushState(null, '', '/');
    });
  })
  .catch((err) => {
    root.render(
      <div style={{ fontFamily: '-apple-system, BlinkMacSystemFont, "Inter", sans-serif', display: 'flex', height: '100vh', background: '#0f172a', color: '#e2e8f0', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ textAlign: 'center', maxWidth: 400 }}>
          <div style={{ fontSize: 20, fontWeight: 700, marginBottom: 8, color: '#ef4444' }}>Authentication Error</div>
          <div style={{ fontSize: 13, color: '#64748b' }}>{err.message || 'Failed to connect to authentication server'}</div>
        </div>
      </div>
    );
  });

reportWebVitals();
